import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'basit-not-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bn-edit">
      <div class="bn-baslik">
        <div class="bn-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
        </div>
        <span>Basit Not</span>
      </div>

      <div class="bn-form">
        <div class="form-grup">
          <label>Not Başlığı</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.baslik || ''"
              (ngModelChange)="guncelle('baslik', $event)"
              placeholder="Not başlığını girin..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Kategori</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.kategori"
              (ngModelChange)="guncelle('kategori', $event)"
              nzPlaceHolder="Kategori seçin..."
              style="width:100%"
              [nzCustomTemplate]="bnKatTpl">
              <nz-option nzValue="genel" nzLabel="Genel" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#3b82f6"></span><span class="sel-ad">Genel</span></div>
              </nz-option>
              <nz-option nzValue="acil" nzLabel="Acil" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#ef4444"></span><span class="sel-ad">Acil</span></div>
              </nz-option>
              <nz-option nzValue="bilgi" nzLabel="Bilgi" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#10b981"></span><span class="sel-ad">Bilgi</span></div>
              </nz-option>
              <nz-option nzValue="hatirlatma" nzLabel="Hatirlatma" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><span class="sel-ad">Hatirlatma</span></div>
              </nz-option>
            </nz-select>
            <ng-template #bnKatTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="bnKatRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .bn-edit { display: flex; flex-direction: column; gap: 0; padding: 0; }

    .bn-baslik {
      display: flex; align-items: center; gap: 10px;
      padding: 12px 16px; margin-bottom: 4px; border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .bn-baslik-ikon {
      width: 32px; height: 32px; border-radius: 8px;
      display: flex; align-items: center; justify-content: center;
      background: linear-gradient(135deg, #059669, #10b981);
      color: #fff; flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(5, 150, 105, 0.35);
      position: relative;
    }

    .bn-baslik-ikon::after {
      content: ''; position: absolute; inset: 0; border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%; animation: shimmer 3s infinite linear; pointer-events: none;
    }

    .bn-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }

    .bn-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }

    .form-grup { display: flex; flex-direction: column; gap: 5px; }

    .form-grup label {
      font-size: 11px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); transition: color 0.2s ease;
    }

    .form-grup:focus-within label { color: var(--py-link, #1890ff); }

    .input-wrap { position: relative; }

    .input-glow {
      position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px;
      background: linear-gradient(90deg, #059669, #10b981, #059669);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
      opacity: 0; pointer-events: none; z-index: 1;
    }

    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }

    .input-wrap input[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px;
      padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap input[nz-input]:hover { border-color: var(--py-kenarlik-hover, #b3b3b3); background: var(--py-arkaplan-hover, #f5f5f5); }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1); outline: none; }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-hover, #b3b3b3) !important; background: var(--py-arkaplan-hover, #f5f5f5) !important; }
    .input-wrap:focus-within ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-aktif, #1890ff) !important; background: var(--py-input-arka, #fff) !important; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important; }

    @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
  `],
})
export class BasitNotEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();

  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  bnKatRenk(v: string): string {
    const m: Record<string, string> = { 'genel': '#3b82f6', 'acil': '#ef4444', 'bilgi': '#10b981', 'hatirlatma': '#f59e0b' };
    return m[v] || '#3b82f6';
  }

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }
}
